/**
 * 正则相关
 */
 const rules = {
    email:
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    password: /^(?![\d]+$)(?![a-zA-Z]+$)(?![@$!%*#_~?&^]+$)[\da-zA-Z@$!%*#_~?&^]{8,20}$/,
    name: /^[\u4e00-\u9fa5a-zA-Z1-9]{1,50}$/,
    phone: /^[1][2,3,4,5,6,7,8,9][0-9]{9}$/
  };
  
  export default rules;